export default __webpack_public_path__ + "static/media/after.e5210979.png";